const _ = require('lodash')

export default class Translations {
    __translations = []
    model = '/api/data/translations'
    constructor() {
        this.__getAll()
    }

    __getAll() {
        const event = new Event('translation-loaded');
        fetch(this.model).then(response => {
            response.json().then(data => {
                this.__translations = data
                window.dispatchEvent(event)
            })
        });
    }

    translate(type, code, to) {
        if(code !== undefined){
            let translation = _.head(_.filter(this.__translations, (value) => {
                return value.code === code && value.type === type
            }))
            if(translation && translation.languages !== null){
                let languages = JSON.parse(translation.languages)
                return (languages[to] !== undefined && languages[to] !== '')? languages[to] : code
            }
            else{
                return code
            }
        }
    }
}